import { AnalyticsService } from './../../_services/analytics.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quiz-analytics',
  templateUrl: './quiz-analytics.component.html',
  styleUrls: ['./quiz-analytics.component.css']
})
export class QuizAnalyticsComponent implements OnInit {

  dataList=[]
 
  constructor(private analyticService:AnalyticsService) { }

  ngOnInit(): void {
    this.analyticService.getQuiz().subscribe(
      x=>{
        this.dataList=x
      }
    ) 
  }
}
